module.exports = __webpack_public_path__ + "images/cert-HACCP.517bbe94.png";